import { ExtensibilityModeEnum } from 'owa-addins-types';
import { setPreviousNavigationState } from '../PreviousNavigationState';
import { TaskPaneType, terminateTaskPaneAddinCommand } from 'owa-addins-store';

export default function terminateAddinNavigationOperation() {
    terminateTaskPaneAddinCommand(TaskPaneType.Persistent);

    setPreviousNavigationState({
        hostItemIndex: null,
        mode: ExtensibilityModeEnum.Unknown,
        isNullSent: false,
    });
}
